var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dg-showmore",on:{"click":function($event){$event.preventDefault();return _vm.showMore.apply(null, arguments)}}},[(_vm.content.length > 250 && _vm.showMoreVisible)?_c('div',[_vm._v(" "+_vm._s(_vm.contentTruncate)),_c('dg-link',[_vm._v(_vm._s(_vm.$t("dsr.show_more")))])],1):_c('div',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }